import { useState } from 'react'
import SiteCreateForm from '../SiteCreateForm'
import { SiteForm } from '../../models/site.model'


export default function SiteCreate({ setBlockScreen }: any) {

  const [siteForm, setSiteForm] = useState<SiteForm>({
    name: '',
    code: '',
    description: '',
    address: '',
    longitude: '',
    latitude: '',
    created_date: ','
  })

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    setSiteForm({
      ...siteForm,
      [event.target.name]: event.target.value
    });
  }

  const handleSelection = (key: string, value: string): void => {
    setSiteForm({
      ...siteForm,
      [key]: value
    });
  }

  return (
    <SiteCreateForm
      setBlockScreen={setBlockScreen}
      action='create'
      siteForm={siteForm}
      handleChange={handleChange}
      handleSelection={handleSelection} />
  )
}